import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAiVisCssVars } from '../pages/ai-vis/aivisTheme';
import { hasAdminConsoleAccess } from '../pages/ai-vis/aivisRoles';
import '../pages/ai-vis/ai-vis.css';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="aivis-auth-page" style={getAiVisCssVars()}>
        <div className="aivis-loading-screen" role="status" aria-live="polite">
          <div className="aivis-loading-dot" />
          <span>Loading…</span>
        </div>
      </div>
    );
  }

  if (!hasAdminConsoleAccess(user)) {
    return <Navigate to="/ai-vis/home" replace />;
  }

  return children;
}
